
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="getCancelar">
        <template #header>
          <h4 class="not-margin">
            Crear registro
          </h4>
        </template>
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template>
                                <vs-option v-for="option in institucionesArray" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <template v-if="ciclosEscolares.length">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="programa" class="labelInput">
                            Programa
                        </label>
                        <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="nivel != ''" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <template v-if="programas.length" autocomplete="off">
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                        <div v-if="programa !== ''" @click="programa = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="nivel" class="labelInput">
                            Nivel Académico
                        </label>
                        <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="programa != ''">
                            <template #message-danger v-if="errorFields.includes('nivel')">
                                Requerido
                            </template>
                            <template v-if="niveles.length" autocomplete="off">
                                <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                        <div v-if="nivel !== ''" @click="nivel = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Método de descuento</label>
                        <vs-select filter class="pt-0" placeholder="Método de descuento" v-model="metodo" @input="metodoClear(metodo)">
                            <template #message-danger v-if="errorFields.includes('metodo')">
                                Requerido
                            </template>
                            <vs-option label="Monto" value="monto">
                                Monto
                            </vs-option>
                            <vs-option label="Porcentaje" value="porcentaje">
                                Porcentaje
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6" v-if="metodo == 'monto'">
                    <form autocomplete="off">
                        <label class="labelInput">Monto</label>
                        <vs-input class="pt-0" v-model="monto" placeholder="Monto">
                            <template #message-danger v-if="errorFields.includes('monto')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6" v-if="metodo == 'porcentaje'">
                    <form autocomplete="off">
                        <label class="labelInput">Porcentaje</label>
                        <vs-input class="pt-0" v-model="porcentaje" placeholder="Porcentaje">
                            <template #message-danger v-if="errorFields.includes('porcentaje')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Fecha de apertura</label>
                        <vs-input
                            class="pt-0"
                            type="date"
                            v-model="fecha_apertura"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_apertura')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Fecha de cierre</label>
                        <vs-input
                            class="pt-0"
                            type="date"
                            v-model="fecha_cierre"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_cierre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Código de detalle de promoción</label>
                        <vs-select filter :loading="loadingSelect" class="pt-0" placeholder="Cargo" v-model="abono" :key="abonosId">
                            <template #message-danger v-if="errorFields.includes('abono')">
                                Requerido
                            </template>
                            <vs-option v-for="(option, i) in abonos" :key="i" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Código de detalle a quién aplica</label>
                        <vs-select filter :loading="loadingSelect" class="pt-0" placeholder="Cargo" v-model="cargo" :key="cargoId">
                            <template #message-danger v-if="errorFields.includes('cargo')">
                                Requerido
                            </template>
                            <vs-option v-for="(option, i) in cargos" :key="i" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="getCancelar">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getCrearPromociones()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico'
export default {
    props:[
        'value',
        'info',
        'institucionSelect',
        'institucionesArray',
        'cicloSelect',
        'ciclosEscolaresArray'
    ],
    data:() => ({
        active: false,
        programa: '',
        programas: [],
        programaId: (new Date()).getTime(),
        nivel: '',
        niveles: [],
        nivelId: (new Date()).getTime(),
        fecha: '',
        nombre: '',
        errorFields: [],
        institucion: '',
        institucionId: (new Date()).getTime(),
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        metodo: '',
        monto: '',
        porcentaje: '',
        fecha_apertura: '',
        fecha_cierre: '',
        abono: '',
        abonos: [],
        abonosId: (new Date()).getTime(),
        cargo: '',
        cargos: [],
        cargoId: (new Date()).getTime(),
        loadingSelect: false
    }),
    methods: {
        async getCicloEscolar() {
            this.loadingSelect = true
            const { data: response } = await academico.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingSelect = false
        },
        async getPrograma() {
            if(this.institucion){
                this.programa = ''
                this.loadingSelect = true
                const { data: response } = await academico.getPrograma(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingSelect = false
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.nivel = ''
                this.loadingSelect = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingSelect = false
            }
        },
        async getAbonoPromociones() {
            this.loadingSelect = true
            const { data: response } = await academico.getAbonoPromociones()
            this.abonos = response
            this.abonosId = (new Date()).getTime()
            this.loadingSelect = false
        },
        async getCargosPromociones() {
            this.loadingSelect = true
            const { data: response } = await academico.getCargosPromociones()
            this.cargos = response
            this.cargoId = (new Date()).getTime()
            this.loadingSelect = false
        },
        metodoClear(metodo){
            if(metodo == 'monto'){
                this.porcentaje = ''
            }
            if(metodo == 'porcentaje'){
                this.monto = ''
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.institucion)) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('string', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if(this.programa != ''){
                if (!this.checkByType ('string', this.programa)) {
                    this.errorFields.push('programa')
                }
            }
            if(this.nivel != ''){
                if (!this.checkByType ('string', this.nivel)) {
                    this.errorFields.push('nivel')
                }
            }
            if (!this.checkByType ('string', this.metodo)) {
                this.errorFields.push('metodo')
            }
            if(this.metodo == 'monto'){
                if (!this.checkByType ('string', this.monto)) {
                    this.errorFields.push('monto')
                }
            }
            if(this.metodo == 'porcentaje'){
                if (!this.checkByType ('string', this.porcentaje)) {
                    this.errorFields.push('porcentaje')
                }
            }
            if (!this.checkByType ('string', this.fecha_cierre)) {
                this.errorFields.push('fecha_cierre')
            }
            if (!this.checkByType ('string', this.fecha_apertura)) {
                this.errorFields.push('fecha_apertura')
            }
            if (!this.checkByType ('string', this.abono)) {
                this.errorFields.push('abono')
            }
            if (!this.checkByType ('string', this.cargo)) {
                this.errorFields.push('cargo')
            }
            if (!this.errorFields.length){
                const base = {
                    ciclo_escolar_id: this.cicloEscolar,
                    codigo_detalle_abono_id: this.abono,
                    codigo_detalle_cargo_id: this.cargo,
                    fecha_apertura: this.fecha_apertura,
                    fecha_cierre: this.fecha_cierre,
                    institucion_id: this.institucion,
                    metodo_descuento: this.metodo,
                    nivel_academico_id: this.nivel,
                    programa_id: this.programa,
                 }
                 if(this.metodo == 'monto'){
                     base.monto = this.monto
                 }
                 if(this.metodo == 'porcentaje'){
                     base.porcentaje = this.porcentaje
                 }
                const payload = Object.assign(base);
                return payload
            } else {
                return null
            }
        },
        async getCrearPromociones(){
            const payload = this.sanityForm()
            if(payload){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.getCrearPromociones(payload)
                    loading.close()
                    this.active = false
                    this.$emit('refreshTable', this.institucion, this.cicloEscolar)
                    this.getResetear()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se a creado con éxito el registro.'
                    })
                }catch{
                    this.getResetear()
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal.',
                        text: 'Póngase en contacto con el administrador.'
                    })
                }
            }
        },
        getResetear(){
            this.cicloEscolar = ''
            this.abono = ''
            this.cargo = ''
            this.fecha_apertura = ''
            this.fecha_cierre = ''
            this.institucion = ''
            this.metodo = ''
            this.nivel = ''
            this.programa = ''
            this.monto = ''
            this.porcentaje = ''
        },
        getCicloInstituto(){
            this.institucion = this.institucionSelect
            this.cicloEscolar = this.cicloSelect
        }, 
        getCancelar(){
            this.institucion = this.institucionSelect
            this.cicloEscolar = this.cicloSelect
            this.metodo = ''
            this.monto = ''
            this.porcentaje = ''
            this.abono = ''
            this.fecha_apertura = ''
            this.fecha_cierre = ''
            this.abono = ''
            this.cargo = ''
            this.programa = ''
            this.nivel = ''
            this.active = false
        },
    },
    watch:{
      value (val) {
          this.active = val
          this.getCicloInstituto()
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      institucion(){
          this.getCicloEscolar()
          this.getPrograma()
          this.getNivelAcademico()
          this.getAbonoPromociones()
          this.getCargosPromociones()
      }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>